import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {
  applyFilters,
  filterByModel,
  handleResetFilters,
} from "../../../Utils/FiltersManager";
import { toggleSort, applySort } from "../../../Utils/SortManager";
import { setEnvironmentColors } from "../../../Utils/EnvironnementColor";
import {
  renderHeaderRow,
  renderFilterRow,
  renderDataRow,
} from "../../../Utils/ColumnManager";
import UploadAttachmentModal from "../../../Utils/Modals/UploadAttachmentModal";
import DateFilterModal from "../../../Utils/Modals/DateFilterModal";
import { parseCustomDate } from "../../../Utils/DateManager";
import Pagination, { useRedirectCurrentPage } from "../../../Utils/Pagination";
import RelaunchDoc from "../../../UtilsAdmin/AdmModals/RelaunchDoc";
import RelaunchInstance from "../../../UtilsAdmin/AdmModals/RelaunchInstance";
import "../../../Admin/Dashboard/default/AdmTabDoc/AdmDocsTable.css";

const DocsTableComponent = ({
  data = [],
  setData = () => {},
  modelName = "",
  modelId,
  clientId,
  instanceId,
  page,
  tableConfig,
  modelInstanceStatuses = [],
  selectedDocuments,
  setSelectedDocuments,
  filter,
  setFilter,
  setReturn,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [sortField, setSortField] = useState("CreationDate");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemPerPage] = useState(10);
  const [colorFilter, setColorFilter] = useState("#235073");
  const [colorFilterAction, setColorFilterAction] = useState("#ffffff");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileExtension, setFileExtension] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalInstance, setShowModalInstance] = useState(false);
  const [dateRangeFilter, setDateRangeFilter] = useState({
    fromDate: null,
    toDate: null,
    filterType: "between",
  });
  const [isDateFilterVisible, setIsDateFilterVisible] = useState(false);
  const role = Cookies.get("Role");
  const redirect = role === "superadmin" ? "/Admin/AdmLotsTable" : "/User/DefaultLots";

  const configKey = modelName ? `${modelName}Docs` : "DefaultDocs";
  const config = tableConfig[configKey] || tableConfig["DefaultDocs"];

  useEffect(() => {
    setEnvironmentColors([
      [setColorFilter, "colorFilter"],
      [setColorFilterAction, "colorFilterAction"],
    ]);
  }, []);

  useEffect(() => {
    const filtered = applyFilters(data, filter, dateRangeFilter, parseCustomDate);
    const modelFiltered = filterByModel(filtered, filter);
    setFilteredData(modelFiltered);
  }, [data, filter, dateRangeFilter]);

  useRedirectCurrentPage(filteredData, itemsPerPage, currentPage, setCurrentPage);

  const handleSort = (field) => {
    toggleSort(field, sortField, setSortField, sortOrder, setSortOrder);
  };

  const handleRelaunchClick = (items) => {
    if (Array.isArray(items)) {
      setSelectedDocuments(items);
    } else if (items.DocId) {
      setSelectedDocuments([items.DocId]);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDocuments([]);
  };

  const handleRelaunchClickInstance = () => {
    setShowModalInstance(true);
  };

  const handleCloseModalInstance = () => {
    setShowModalInstance(false);
  };

  const toggleDateFilterVisibility = () => {
    setIsDateFilterVisible(!isDateFilterVisible);
  };

  const getUniqueValuesByPath = (data, path) => {
    const getNestedValue = (obj, path) =>
      path.split(".").reduce((acc, part) => acc && acc[part], obj);
    return [...new Set(data.map((item) => getNestedValue(item, path)).filter(Boolean))];
  };

  const generateUniqueValuesByKey = (data, columns) => {
    return columns.reduce((acc, col) => {
      if (col.key) {
        acc[col.key] = getUniqueValuesByPath(data, col.key);
      }
      return acc;
    }, {});
  };

  const uniqueValuesByKey = generateUniqueValuesByKey(data, config);
  const OldStatus = [...new Set(data.map((item) => item.OldStatus))];
  const uniqueStatuses = [...new Set(data.map((item) => item.Status))];

  const context = {
    columns: config,
    data,
    selectedDocuments,
    setSelectedDocuments,
    colorFilter,
    colorFilterAction,
    sortField,
    sortOrder,
    handleSort,
    handleResetFilters,
    setFilter,
    filter,
    t,
    openModal: () => setModalIsOpen(true),
    setSelectedDocumentId,
    instanceId,
    modelId,
    uniqueValuesByKey,
    tableId: "Docs",
    handleRelaunchClick,
    handleRelaunchClickInstance,
    page,
    modelInstanceStatuses,
    navigate,
    setData,
    configKey,
  };

  const attachmentTypes = ["jpg", "png", "dwg"];

  return (
    <>
      <div className="page-container">
        <div className="table-responsive style_table_responsive">
          <table className="table table-striped" style={{ lineHeight: 1 }}>
            <thead className="style_thead">
              {renderHeaderRow(config, colorFilter, toggleDateFilterVisibility, t)}
            </thead>
            <tbody className="style_tbody">
              {renderFilterRow(config, context, OldStatus, uniqueStatuses, t)}
              {applySort(filteredData, sortField, sortOrder).length === 0 ? (
                <tr>
                  <td
                    colSpan={config.length}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    {t("No data to display")}
                  </td>
                </tr>
              ) : (
                applySort(filteredData, sortField, sortOrder)
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )
                  .map((item, index) =>
                    renderDataRow(item, config, context, index)
                  )
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination d-flex justify-content-center mt-2">
        
            {modelName !== "Plan01" && setReturn && (
            <button
              className="btn btn-danger"
              onClick={() => navigate(redirect)}
              style={{ marginLeft: "2.5px", marginRight: "2.5px" }}
            >
              {t("Back")}
            </button>
          )}
          <select
            style={{ marginLeft: "2.5px", marginRight: "2.5px" }}
            value={itemsPerPage}
            onChange={(e) => setItemPerPage(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
          <Pagination
            filteredData={filteredData}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>

      <UploadAttachmentModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        fileState={{
          selectedFile,
          setSelectedFile,
          fileExtension,
          setFileExtension,
          errorMessage,
          setErrorMessage,
        }}
        documentInfo={{
          instanceId,
          selectedDocumentId,
          modelId,
        }}
        attachmentTypes={attachmentTypes}
        t={t}
      />
      {isDateFilterVisible && (
        <DateFilterModal
          dateRangeFilter={dateRangeFilter}
          setDateRangeFilter={setDateRangeFilter}
          onClose={toggleDateFilterVisibility}
        />
      )}
      {showModal && (
        <RelaunchDoc
          documentIds={selectedDocuments}
          documentData={data.filter((doc) =>
            selectedDocuments.includes(doc.DocId)
          )}
          onClose={handleCloseModal}
        />
      )}
      {showModalInstance && (
        <RelaunchInstance onClose={handleCloseModalInstance} />
      )}
    </>
  );
};

export default DocsTableComponent;
